import { ExplainerExpression, ExplainerImageConfig } from "../types/explainer";
import { isExplainerImage } from "../utils";

/**
 * Custom hook to handle explainer image configuration
 * Processes the image data and returns a properly formatted image configuration
 *
 * @param data - The explainer expression data containing image information
 * @param language - The current language for internationalization
 * @returns A formatted image configuration or undefined if no image is present
 */
export const useExplainerImage = (
  data: ExplainerExpression,
  language: string | undefined
): ExplainerImageConfig | undefined => {
  if (!data.explainerImage || !language) return undefined;

  if (typeof data.explainerImage === "string") {
    return {
      src: `images/explainers/${language}/${data.explainerImage}`,
    };
  }

  if (isExplainerImage(data.explainerImage)) {
    return {
      src: `images/explainers/${language}/${data.explainerImage.src}`,
      size: data.explainerImage.size,
    };
  }

  return undefined;
};
